import React, { useEffect, useState } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  useMap,
  useMapEvents,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import "leaflet-routing-machine";

// Fix for default marker icons in Leaflet
import markerIconPng from "leaflet/dist/images/marker-icon.png";
import "leaflet/dist/images/marker-shadow.png";
// import markerShadowPng from "leaflet/dist/images/marker-shadow.png";
// import redMarkerIconPng from "path-to-red-marker-icon.png"; // Use red marker icon image

let DefaultIcon = L.icon({
  iconUrl: markerIconPng,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

// Red marker icon for the destination
let RedIcon = L.icon({
  // iconUrl: redMarkerIconPng, // Red marker icon image
  iconUrl:
    "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png",
  // shadowUrl: markerShadowPng,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

L.Marker.prototype.options.icon = DefaultIcon;

export default function LocationMap(props) {
  const [currentLocation, setCurrentLocation] = useState(null);
  const [destinationLocation, setDestinationLocation] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [fromLocation, setFromLocation] = useState("");
  const [toLocation, setToLocation] = useState("");

  useEffect(() => {
    // Get the current location using the Geolocation API
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setCurrentLocation({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
          const currentLoc =
            position.coords.latitude + "," + position.coords.longitude;
          setFromLocation(currentLoc);
        },
        (error) => {
          console.error("Error getting location:", error);
        }
      );
    }
  }, []);

  const handleSearch = async () => {
    if (searchQuery) {
      try {
        // Use Nominatim API for geocoding
        const response = await fetch(
          `https://nominatim.openstreetmap.org/search?format=json&q=${searchQuery}`
        );
        const data = await response.json();
        if (data.length > 0) {
          const location = data[0];
          console.log("Location: ", location);
          setDestinationLocation({
            lat: parseFloat(location.lat),
            lng: parseFloat(location.lon),
          });
        } else {
          alert("Location not found.");
        }
      } catch (error) {
        console.error("Error fetching geolocation:", error);
      }
    }
  };
  const handleSearch1 = async (e) => {
    setSearchQuery(e.target.value);

    if (e.target.value) {
      try {
        // Fetch suggestions from Nominatim API
        const response = await fetch(
          `https://nominatim.openstreetmap.org/search?format=json&q=${e.target.value}&limit=5`
        );
        const data = await response.json();
        setSuggestions(data);
      } catch (error) {
        console.error("Error fetching suggestions:", error);
      }
    } else {
      setSuggestions([]);
    }
  };

  const handleSuggestionClick = (location) => {
    setDestinationLocation({
      lat: parseFloat(location.lat),
      lng: parseFloat(location.lon),
    });
    setSearchQuery(location.display_name); // Set search input to the selected suggestion
    setSuggestions([]); // Clear suggestions
    setToLocation(location.display_name); // Clear suggestions
  };

  function LocationMarker() {
    const map = useMapEvents({
      click() {
        map.locate();
      },
      locationfound(e) {
        setCurrentLocation(e.latlng);
        map.flyTo(e.latlng, map.getZoom());
      },
    });

    return currentLocation === null ? null : (
      <Marker position={currentLocation}>
        <Popup>You are here</Popup>
      </Marker>
    );
  }

  return (
    <div>
      <div>
        <input
          type="text"
          value={searchQuery}
          // onChange={(e) => setSearchQuery(e.target.value)}
          onChange={handleSearch1}
          placeholder="Enter destination"
        />
        {suggestions.length > 0 && (
          <ul style={{ listStyleType: "none", padding: 0 }}>
            {suggestions.map((suggestion) => (
              <li
                key={suggestion.place_id}
                onClick={() => handleSuggestionClick(suggestion)}
                style={{
                  cursor: "pointer",
                  background: "#f0f0f0",
                  padding: "5px",
                  margin: "2px 0",
                }}
              >
                {suggestion.display_name}
              </li>
            ))}
          </ul>
        )}
        {/* <button onClick={handleSearch}>Search</button> */}
      </div>

      {currentLocation && (
        <MapContainer
          center={currentLocation}
          zoom={13}
          style={{ height: "800px", width: "100%" }}
        >
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution="&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors"
          />
          {/* <Marker position={currentLocation}>
            <Popup>{fromLocation}</Popup>
          </Marker> */}

          <LocationMarker />
          {destinationLocation && (
            <Marker position={destinationLocation} icon={RedIcon}>
              <Popup>{toLocation}</Popup>
            </Marker>
          )}
          {destinationLocation && (
            <RoutingMachine start={currentLocation} end={destinationLocation} />
          )}
        </MapContainer>
      )}
    </div>
  );
}

const RoutingMachine = ({ start, end }) => {
  const map = useMap();

  useEffect(() => {
    if (!map) return;

    const routingControl = L.Routing.control({
      waypoints: [L.latLng(start.lat, start.lng), L.latLng(end.lat, end.lng)],
      lineOptions: {
        styles: [{ color: "#6FA1EC", weight: 4 }],
      },
      createMarker: () => null, // Hide default markers
      routeWhileDragging: false, // Disable route dragging
      addWaypoints: false, // Disable adding waypoints
      draggableWaypoints: false, // Disable dragging waypoints
      showAlternatives: false, // No alternative routes
      fitSelectedRoutes: true,
      // Disable the default directions panel
      router: L.Routing.osrmv1({}),
      show: false,
    }).addTo(map);

    // Manually remove the itinerary control (directions panel)
    const itineraryControl = document.querySelector(
      ".leaflet-routing-container"
    );
    if (itineraryControl) {
      itineraryControl.style.display = "none"; // Hides the directions panel
    }

    return () => {
      map.removeControl(routingControl); // Clean up on unmount
    };
  }, [map, start, end]);

  return null;
};
